import * as Yup from "yup";

export const keywordValidationSchema = Yup.object().shape({
	name: Yup.string().required(),
});
